// extracted by mini-css-extract-plugin
export default {"component":"Collection_component__2nErm"};